<template>
    <section class="bg-gray-100">
        <div class="container mx-auto justify-center pt-4 pb-20 lg:py-20">
            <div
                class="flex flex-col lg:flex-row-reverse w-5/6 justify-center mx-auto items-center"
            >
                <div class="mb-8 lg:mb-0 lg:w-1/2 lg:ml-20">
                    <img
                        src="../assets/images/FO RND BLU BG.png"
                        alt="FO Groups"
                    />
                </div>

                <div class="lg:w-1/2">
                    <h2 class="text-5xl font-medium mb-6">Our Aim</h2>

                    <p class="text-xl leading-relaxed mb-6">
                        Our aim is to bring engineering, design and technology
                        together to deliver dependable solutions that improve
                        everyday life. From individual services to complete
                        projects, we work to meet our clients’ needs through
                        thoughtful planning, quality workmanship, and
                        responsible execution.
                    </p>

                    <p class="text-xl leading-relaxed">
                        We aspire to grow across engineering disciplines,
                        adopt useful new technologies, and create opportunities
                        for skilled professionals. Through lasting partnerships
                        and sustainable practices, we seek to contribute to
                        the social and economic progress of our communities
                        and the nation.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>
